module.exports = __webpack_public_path__ + "img/journey.c0af53da.svg";